var $els = document.querySelectorAll('.act-publish-notification');
function act_publish_notification_submit(e)
{
    e.preventDefault();
    const $form = e.currentTarget;
    const $error = $form.querySelector('.act-publish-notification__error');
    if ($error) {
        $error.remove();
    }
    const $success = $form.querySelector('.act-publish-notification__success');
    if ($success) {
        $success.remove();
    }
    $form.classList.remove('act-publish-notification--error');
    $form.classList.remove('act-publish-notification--success');
    $form.classList.add('act-publish-notification--loading');

    let formdata = new FormData($form);
    let params = new URLSearchParams(formdata);
    //wp.ajax uses jQuery
    //We will do it ourselves
    let request = new XMLHttpRequest();
    request.open('GET', ajaxurl+'?'+params.toString(), true);
    request.onload = function() {
        const $div = document.createElement('div');
        const response = JSON.parse(this.responseText);
        const className = response.success == 1 ? 'success' : 'error';
        $div.classList.add('act-publish-notification__'+className);
        $div.innerHTML = response.data.message;
        $form.classList.add('act-publish-notification--'+className);
        $form.classList.remove('act-publish-notification--loading');
        $form.append($div);
    }
    request.onerror = function() {
        const response = JSON.parse(this.responseText);
        const $error = document.createElement('div');
        $error.classList.add('act-publish-notification__error');
        $error.innerHTML = "Erreur lors de la connection au serveur.";
        $form.classList.add('act-publish-notification--error');
        $form.classList.remove('act-publish-notification--loading');
        $form.append($error);
    };
    request.send();
}
$els.forEach($el => {
    $el.addEventListener('submit', act_publish_notification_submit)
})